import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const userAtom = atomWithStorage<{
    id: string;
    name?: string | null;
    email?: string | null;
    avatar?: string;
    created?: Date;
    isSynced?: boolean | null;

    isLocal?: boolean;
}>(
    "user",
    {
        id: "",
    }
);

export const teamActiveAtom = atomWithStorage<{ id: string; name: string } | null>("teamActive", null);

export const userSubscriptionAtom = atom<{
    id: string; planPurchase: { plan: { name: string }; }; created: Date | null; planPurchaseId: string; startDate: Date | null; endDate: Date | null;
} | null | undefined>(null)

export const upgradeModalAtom = atomWithStorage<{ isOpen?: boolean, lastOpen?: Date, subscribed?: boolean }>('upgradeModalAtom', {})

/**
 * Signup discount urgency tracking.
 * Records when the user first saw the upgrade prompt.
 * A time-limited discount is shown for DISCOUNT_HOURS after `firstSeenAt`.
 */
export const SIGNUP_DISCOUNT_HOURS = 48;
export const signupDiscountAtom = atomWithStorage<{
    /** ISO timestamp of when user first saw the upgrade prompt */
    firstSeenAt?: string;
}>('signupDiscount', {})

export const codeModalAtom = atom({ isOpen: false })

export const apiKeyModalAtom = atom<boolean | 'openai' | 'anthropic' | 'google' | 'xai' | 'deepseek' | 'glm' | 'kimi' | 'qwen'>(false)
